<template>
  <div id="award-edit" class="professional-award-form">
    <!-- Professional Overlay Loading -->
    <v-overlay :value="OverlayLoadingFlag" class="professional-overlay">
      <div class="loading-container">
        <v-progress-circular
          indeterminate
          size="64"
          width="4"
          color="#1976d2"
        ></v-progress-circular>
        <p class="loading-text mt-4">Processing your award application...</p>
      </div>
    </v-overlay>

    <!-- Main Card -->
    <v-card class="main-form-container" elevation="6">
      <!-- Header -->
      <v-card-title class="professional-form-header pa-6">
        <div class="header-content">
          <div class="title-section">
            <div class="main-title-wrapper">
              <v-icon size="32" color="#1976d2" class="mr-3">mdi-trophy</v-icon>
              <div class="title-text">
                <h1 class="form-main-title">{{ PageTitle }}</h1>
                <div class="award-badge mt-2" v-if="row != ''">
                  <v-chip color="#ff9800" text-color="white" small>
                    <v-icon left size="14">mdi-star</v-icon>
                    {{ row.AwardTypeTitleTxt }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <router-link to="/national/individual-award/list">
              <v-btn
                color="#ff9800"
                elevation="2"
                rounded
                class="action-btn mr-3 white--text"
              >
                <v-icon left size="18">mdi-arrow-left</v-icon> Back
              </v-btn>
            </router-link>

            <v-btn
              @click.prevent="refreshPageData"
              color="#2ecc71"
              elevation="2"
              rounded
              class="action-btn white--text"
            >
              <v-icon left size="18">mdi-refresh</v-icon> Refresh
            </v-btn>
          </div>
        </div>

        <div class="description-section mt-4" v-if="PageDescription">
          <div class="description-wrapper">
            <v-icon size="20" color="#666" class="mr-2"
              >mdi-information-outline</v-icon
            >
            <p class="form-description">{{ PageDescription }}</p>
          </div>
        </div>
      </v-card-title>

      <!-- Body -->
      <v-card-text class="form-main-content pa-6">
        <v-container>
          <!-- Loading -->
          <div class="form-loading-section" v-if="LoadingFlag">
            <div class="loading-wrapper">
              <v-progress-circular
                indeterminate
                color="#1976d2"
                size="48"
                width="4"
              ></v-progress-circular>
              <p class="loading-text mt-4">Loading award details...</p>
            </div>
          </div>

          <!-- Award Details -->
          <v-card
            class="award-details-card mb-6"
            elevation="3"
            v-if="row != ''"
          >
            <v-card-title class="award-details-header">
              <v-icon size="24" color="#1976d2" class="mr-3"
                >mdi-certificate</v-icon
              >
              <span class="section-title">Award Details</span>
            </v-card-title>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" lg="4" sm="12">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Status</h6>
                    <div class="detail-value">
                      <v-chip
                        :color="row.AwardStatusColor"
                        text-color="white"
                        class="status-chip"
                        >{{ row.AwardStatusTxt }}</v-chip
                      >
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" lg="4" sm="12">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Register Number</h6>
                    <div class="detail-value">
                      {{ row.AwardRegisterNumber }}
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" lg="4" sm="12">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Title</h6>
                    <div class="detail-value">{{ row.AwardTypeTitleTxt }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Form -->
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            @submit.prevent="getTotalNatConLomAwardsDetails"
            class="professional-form"
          >
            <div class="form-content-wrapper">
              <!-- Member Selection -->
              <v-card class="member-selection-card mb-6" elevation="3">
                <v-card-title class="member-selection-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-account-search</v-icon
                  >
                  <span class="section-title">Nominee Selection</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="input-section">
                        <div class="input-label">
                          <span class="required-indicator">*</span> Select
                          Member
                          <span class="input-hint"
                            >(Only Current Year Dues paid member)</span
                          >
                        </div>
                        <v-autocomplete
                          :reduce="(option) => option.value"
                          :loading="MemberIdOptionsLoading"
                          :items="MemberIdOptions"
                          :rules="MemberIdRules"
                          v-model="MemberId"
                          required
                          outlined
                          dense
                          clearable
                          class="professional-input"
                        >
                          <template v-slot:selection="{ item }">
                            <div class="member-selection-item">
                              <img
                                class="member-avatar mr-2"
                                width="40"
                                height="40"
                                :src="item.photo"
                              />
                              <span>{{ item.text }}</span>
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <div class="member-dropdown-item">
                              <img
                                class="member-avatar mr-2"
                                width="40"
                                height="40"
                                :src="item.photo"
                              />
                              <span>{{ item.text }}</span>
                            </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" v-if="Member.membership_id != ''">
                      <member-details
                        cardTitle="Award Nominee Member"
                        :Member="Member"
                        class="nominee-card"
                      ></member-details>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" v-if="Member && Member.membership_id != ''">
                      <!-- success state when member is registered for NatCon -->
                      <template v-if="NatconRegistrationFlag">
                        <v-card
                          class="natcon-alert-card pa-3 elevation-1 mt-3"
                          style="
                            background: rgba(0, 200, 83, 0.12);
                            border: 1px solid rgba(0, 200, 83, 0.3);
                          "
                        >
                          <v-row align="center" no-gutters>
                            <v-col cols="auto">
                              <v-avatar
                                size="56"
                                class="mr-4"
                                color="green lighten-5"
                              >
                                <v-icon color="green darken-2" size="28"
                                  >mdi-check-circle</v-icon
                                >
                              </v-avatar>
                            </v-col>

                            <v-col>
                              <div
                                class="natcon-alert-title"
                                style="font-weight: 600; color: #1b5e20"
                              >
                                NatCon Registration Verified
                              </div>

                              <div
                                class="natcon-alert-msg"
                                style="color: #2e7d32"
                              >
                                The member has successfully
                                <strong
                                  >completed the NatCon registration</strong
                                >.
                                <div
                                  class="natcon-alert-extra mt-2"
                                  style="color: #2e7d32"
                                >
                                  You may continue with the award nomination
                                  process.
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="d-none d-sm-flex justify-end"
                            >
                              <v-chip
                                outlined
                                small
                                color="green lighten-5"
                                text-color="green darken-2"
                              >
                                Verified
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>

                      <!-- error state when not registered (keeps existing look + extra line) -->
                      <template v-else>
                        <v-card class="natcon-alert-card pa-3 elevation-1 mt-3">
                          <v-row align="center" no-gutters>
                            <v-col cols="auto">
                              <v-avatar
                                size="56"
                                class="mr-4 pulse-icon"
                                color="red lighten-5"
                              >
                                <v-icon color="red darken-2" size="28"
                                  >mdi-account-alert</v-icon
                                >
                              </v-avatar>
                            </v-col>

                            <v-col>
                              <div class="natcon-alert-title">
                                NatCon Registration Required
                              </div>
                              <div class="natcon-alert-msg">
                                The selected member has
                                <strong
                                  >not completed the NatCon registration</strong
                                >. Award nomination cannot proceed until
                                registration is done.
                                <div class="natcon-alert-extra mt-2">
                                  Please ask the member to finish the NatCon
                                  registration process, or contact support if
                                  assistance is needed.
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="d-none d-sm-flex justify-end"
                            >
                              <v-chip
                                outlined
                                small
                                color="red lighten-5"
                                text-color="red darken-2"
                              >
                                Action Required
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" v-if="Member && Member.membership_id != ''">
                      <!-- success state when member profile is verified -->
                      <template v-if="Member.ProfileStatus === 1">
                        <v-card
                          class="natcon-alert-card pa-3 elevation-1 mt-3"
                          style="
                            background: rgba(0, 200, 83, 0.12);
                            border: 1px solid rgba(0, 200, 83, 0.3);
                          "
                        >
                          <v-row align="center" no-gutters>
                            <v-col cols="auto">
                              <v-avatar
                                size="56"
                                class="mr-4"
                                color="green lighten-5"
                              >
                                <v-icon color="green darken-2" size="28"
                                  >mdi-check-circle</v-icon
                                >
                              </v-avatar>
                            </v-col>

                            <v-col>
                              <div
                                class="natcon-alert-title"
                                style="font-weight: 600; color: #1b5e20"
                              >
                                Profile Verified ✓
                              </div>

                              <div
                                class="natcon-alert-msg"
                                style="color: #2e7d32"
                              >
                                This member's profile has been verified and is
                                eligible to apply for awards.
                              </div>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="d-none d-sm-flex justify-end"
                            >
                              <v-chip
                                outlined
                                small
                                color="green lighten-5"
                                text-color="green darken-2"
                              >
                                Ready
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>

                      <!-- error state when profile is not verified -->
                      <template v-else>
                        <v-card class="natcon-alert-card pa-3 elevation-1 mt-3">
                          <v-row align="center" no-gutters>
                            <v-col cols="auto">
                              <v-avatar
                                size="56"
                                class="mr-4 pulse-icon"
                                color="red lighten-5"
                              >
                                <v-icon color="red darken-2" size="28"
                                  >mdi-alert-circle</v-icon
                                >
                              </v-avatar>
                            </v-col>

                            <v-col>
                              <div class="natcon-alert-title">
                                ⚠ Profile Not Verified
                              </div>
                              <div class="natcon-alert-msg">
                                The selected member's profile has
                                <strong>not been verified</strong>. Profile
                                verification is required to proceed with award
                                nomination.
                                <div class="natcon-alert-extra mt-2">
                                  Please ask the member to complete their
                                  profile verification, or contact support if
                                  assistance is needed.
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="d-none d-sm-flex justify-end"
                            >
                              <v-chip
                                outlined
                                small
                                color="red lighten-5"
                                text-color="red darken-2"
                              >
                                Blocked
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" v-if="Member && Member.membership_id != ''">
                      <!-- success state when member age is verified -->
                      <template v-if="AgeVerificationFlag">
                        <v-card
                          class="natcon-alert-card pa-3 elevation-1 mt-3"
                          style="
                            background: rgba(0, 200, 83, 0.12);
                            border: 1px solid rgba(0, 200, 83, 0.3);
                          "
                        >
                          <v-row align="center" no-gutters>
                            <v-col cols="auto">
                              <v-avatar
                                size="56"
                                class="mr-4"
                                color="green lighten-5"
                              >
                                <v-icon color="green darken-2" size="28"
                                  >mdi-check-circle</v-icon
                                >
                              </v-avatar>
                            </v-col>

                            <v-col>
                              <div
                                class="natcon-alert-title"
                                style="font-weight: 600; color: #1b5e20"
                              >
                                Eligible by age criteria ✓
                              </div>

                              <div
                                class="natcon-alert-msg"
                                style="color: #2e7d32"
                              >
                                This member's age is eligible to apply for this
                                awards.
                              </div>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="d-none d-sm-flex justify-end"
                            >
                              <v-chip
                                outlined
                                small
                                color="green lighten-5"
                                text-color="green darken-2"
                              >
                                Ready
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>

                      <!-- error state when age is not verified -->
                      <template v-else>
                        <v-card class="natcon-alert-card pa-3 elevation-1 mt-3">
                          <v-row align="center" no-gutters>
                            <v-col cols="auto">
                              <v-avatar
                                size="56"
                                class="mr-4 pulse-icon"
                                color="red lighten-5"
                              >
                                <v-icon color="red darken-2" size="28"
                                  >mdi-alert-circle</v-icon
                                >
                              </v-avatar>
                            </v-col>

                            <v-col>
                              <div class="natcon-alert-title">
                                ⚠ You are not eligible due to Age criteria
                              </div>
                              <div class="natcon-alert-msg">
                                {{ AgeVerificationMsg }}
                                <div class="natcon-alert-extra mt-2">
                                  Please contact support if assistance is
                                  needed.
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              cols="auto"
                              class="d-none d-sm-flex justify-end"
                            >
                              <v-chip
                                outlined
                                small
                                color="red lighten-5"
                                text-color="red darken-2"
                              >
                                Blocked
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Scoring table placeholder (keeps functionality) -->
              <jci-india-scoring-table
                v-if="Member.membership_id != ''"
                :AwardCategoryId="row.AwardCategoryId"
                :MemberId="Member.value"
                :AwardTypeId="row.AwardTypeId"
                :LomId="LomId"
                class="scoring-component"
              ></jci-india-scoring-table>

              <br />

              <!-- Judging Criteria -->
              <v-card class="criteria-card mb-6" elevation="3" v-if="row != ''">
                <v-card-title class="criteria-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-clipboard-text</v-icon
                  >
                  <span class="section-title">Judging Criteria</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <div v-if="row == ''" class="empty-state text-center pa-4">
                    <h5 class="text-center text-dark">Nil.</h5>
                  </div>

                  <div
                    class="criteria-question-section mb-6"
                    v-for="(item, index) in row.AwardAnswersArray"
                    :key="index"
                  >
                    <div
                      class="criteria-detail-header mb-4"
                      v-if="item.CriteriaTitleFlag"
                    >
                      <div class="criteria-detail-card">
                        <div class="criteria-detail-content">
                          <h3 class="criteria-title">
                            {{ item.CriteriaTitle }}
                            <small>(score - {{ item.CriteriaScore }})</small>
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div class="question-content-wrapper">
                      <div class="question-label-section mb-3">
                        <h3 class="question-title">
                          <span class="required-indicator">*</span>
                          {{ item.QuestionsText }}
                        </h3>
                      </div>

                      <div class="question-input-section mb-4">
                        <div class="html-editor-wrapper">
                          <vue-editor
                            :id="item.AnswerId"
                            v-model="item.AnswerText"
                            :editorOptions="editorOptions"
                            @text-change="onTextChange($event, item)"
                            placeholder="Please provide your detailed answer here..."
                            class="professional-editor"
                          ></vue-editor>
                          <div
                            class="character-counter mt-1 text-right"
                            :class="{
                              'error--text':
                                getCharacterCount(item.AnswerText) >=
                                item.QuestionsCharsCount,
                            }"
                          >
                            <strong>{{
                              getCharacterCount(item.AnswerText)
                            }}</strong>
                            / {{ item.QuestionsCharsCount }}
                            <span
                              v-if="
                                getCharacterCount(item.AnswerText) >=
                                item.QuestionsCharsCount
                              "
                              class="limit-message"
                              >(Character limit reached)</span
                            >
                          </div>
                        </div>
                      </div>

                      <!-- Attachments -->
                      <div class="attachments-section mt-5">
                        <div
                          class="attachments-header d-flex justify-space-between align-center"
                        >
                          <h3 class="attachments-title">
                            <v-icon size="20" color="#ff9800" class="mr-2"
                              >mdi-paperclip</v-icon
                            >
                            Attachments
                            <small
                              >(Max: {{ item.QuestionsAttachmentMax }})</small
                            >
                          </h3>

                          <v-btn
                            color="primary"
                            fab
                            small
                            elevation="2"
                            class="add-attachment-btn"
                            v-if="
                              item.EventDetails &&
                              item.QuestionsAttachmentMax >
                                item.EventDetails.length
                            "
                            @click="addNewRow(item)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>

                        <div
                          class="attachments-grid mt-4"
                          v-if="
                            item.EventDetails && item.EventDetails.length > 0
                          "
                        >
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              v-for="(data, idx) in item.EventDetails"
                              :key="idx"
                              v-if="data.EventId != ''"
                            >
                              <v-card class="attachment-card" elevation="2">
                                <div class="attachment-actions">
                                  <v-btn
                                    icon
                                    color="error"
                                    small
                                    @click="deleteRow(item.SNo, idx)"
                                    ><v-icon>mdi-delete</v-icon></v-btn
                                  >
                                </div>

                                <v-card-text class="pa-4">
                                  <div class="event-images text-center mb-3">
                                    <viewer
                                      rebuild
                                      :images="data.EventImagesArray"
                                    >
                                      <div class="images-grid">
                                        <img
                                          class="event-image"
                                          width="100"
                                          height="100"
                                          :src="src"
                                          :key="src"
                                          v-for="src in data.EventImagesArray"
                                        />
                                      </div>
                                    </viewer>
                                  </div>

                                  <div class="event-details">
                                    <div class="detail-row mb-2">
                                      <v-icon
                                        size="16"
                                        color="#666"
                                        class="mr-1"
                                        >mdi-calendar</v-icon
                                      ><span class="detail-label"
                                        >Event Date:</span
                                      ><span class="detail-value">{{
                                        data.EventDate
                                      }}</span>
                                    </div>
                                    <div class="detail-row mb-2">
                                      <v-icon
                                        size="16"
                                        color="#666"
                                        class="mr-1"
                                        >mdi-tag</v-icon
                                      ><span class="detail-label"
                                        >Event Name:</span
                                      ><span class="detail-value">{{
                                        data.EventName
                                      }}</span>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>

                        <div class="no-attachments-state mt-4" v-else>
                          <v-alert
                            type="info"
                            text
                            color="grey lighten-1"
                            outlined
                            dense
                            >No attachments added yet. Click the + button to add
                            an attachment.</v-alert
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <template v-if="row != ''">
                <!-- Professional Additional Images Section -->
                <v-card class="attachments-additional-card mb-6 elevation-3">
                  <v-card-title class="attachments-additional-header">
                    <v-icon size="24" color="#7b1fa2"
                      >mdi-image-multiple</v-icon
                    >
                    <span class="section-title">Additional Images</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="AllProjectMax > AllProjectCount"
                      @click="addAttachmentNewRow()"
                      icon
                      small
                      color="#7b1fa2"
                      class="add-attachment-action-btn"
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text class="pa-6">
                    <v-alert type="info" class="info-alert mb-4">
                      <div class="requirements-title">
                        <v-icon color="#7b1fa2" class="mr-2"
                          >mdi-information-variant</v-icon
                        >
                        <strong>Image Requirements:</strong>
                      </div>
                      <ul class="requirements-list">
                        <li>Supported formats: JPG, PNG, JPEG</li>
                        <li>Maximum file size: 2MB per image</li>
                        <li>Maximum attachments: {{ AllProjectMax }}</li>
                      </ul>
                    </v-alert>

                    <!-- Empty State -->
                    <div
                      v-if="
                        (!row.AnswerAttachmentOfficers ||
                          row.AnswerAttachmentOfficers.length === 0) &&
                        (!AllProject || AllProject.length === 0)
                      "
                      class="empty-state-container"
                    >
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#7b1fa2"
                        stroke-width="1.5"
                      >
                        <path
                          d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"
                        ></path>
                        <circle cx="8.5" cy="8.5" r="1.5"></circle>
                        <polyline points="21 15 16 10 5 21"></polyline>
                      </svg>
                      <p class="mt-3">
                        No images added yet. Click the + button to add images.
                      </p>
                    </div>

                    <!-- Image Gallery -->
                    <v-row
                      v-if="
                        (row.AnswerAttachmentOfficers &&
                          row.AnswerAttachmentOfficers.length > 0) ||
                        (AllProject && AllProject.length > 0)
                      "
                      class="image-gallery mt-3"
                    >
                      <!-- Existing attachments from row -->
                      <v-col
                        v-for="(data, index) in row.AnswerAttachmentOfficers"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        :key="'existing-' + index"
                      >
                        <v-card class="image-card">
                          <div class="image-delete-action">
                            <v-btn
                              @click="deleteRow1(index)"
                              icon
                              x-small
                              color="white"
                              class="delete-btn"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                          </div>
                          <div class="image-preview">
                            <viewer rebuild :images="data.EventImagesArray">
                              <v-img
                                v-for="src in data.EventImagesArray"
                                :key="src"
                                :src="src"
                                aspect-ratio="1"
                              ></v-img>
                            </viewer>
                            <viewer rebuild :images="data.AnswerEventImages">
                              <v-img
                                v-for="src in data.AnswerEventImages"
                                :key="src"
                                :src="src"
                                aspect-ratio="1"
                              ></v-img>
                            </viewer>
                            <viewer
                              rebuild
                              :images="data.AnswerInvitationImages"
                            >
                              <v-img
                                v-for="src in data.AnswerInvitationImages"
                                :key="src"
                                :src="src"
                                aspect-ratio="1"
                              ></v-img>
                            </viewer>
                          </div>
                          <v-card-text class="image-details pa-3">
                            <div class="detail-item mb-2">
                              <v-icon size="14" color="#4A148C"
                                >mdi-calendar</v-icon
                              >
                              <span class="detail-label">Date:</span>
                              <span class="detail-value">{{
                                data.EventDate
                              }}</span>
                            </div>
                            <div class="detail-item mb-2">
                              <v-icon size="14" color="#4A148C">mdi-tag</v-icon>
                              <span class="detail-label">Event:</span>
                              <span class="detail-value">{{
                                data.EventName
                              }}</span>
                            </div>
                            <div class="detail-item">
                              <v-icon size="14" color="#4A148C"
                                >mdi-file-document</v-icon
                              >
                              <span class="detail-label">Desc:</span>
                              <span class="detail-value">{{
                                data.AnswerJciEventDescription
                              }}</span>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- New attachments from AllProject -->
                      <v-col
                        v-for="(data1, k) in AllProject"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        :key="'new-' + k"
                      >
                        <v-card class="image-card">
                          <div class="image-delete-action">
                            <v-btn
                              @click="deleteAttachmentRow(k)"
                              icon
                              x-small
                              color="white"
                              class="delete-btn"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                          </div>
                          <div class="image-preview">
                            <viewer rebuild :images="data1.AnswerEventImageUrl">
                              <v-img
                                v-for="src in data1.AnswerEventImageUrl"
                                :key="src"
                                :src="src"
                                aspect-ratio="1"
                              ></v-img>
                            </viewer>
                          </div>
                          <v-card-text class="image-details pa-3">
                            <div class="detail-item mb-2">
                              <v-icon size="14" color="#4A148C"
                                >mdi-calendar</v-icon
                              >
                              <span class="detail-label">Date:</span>
                              <span class="detail-value">{{
                                data1.AnswerEventDate
                              }}</span>
                            </div>
                            <div class="detail-item">
                              <v-icon size="14" color="#4A148C">mdi-tag</v-icon>
                              <span class="detail-label">Event:</span>
                              <span class="detail-value">{{
                                data1.AnswerEventName
                              }}</span>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>

              <!-- Professional Video Upload Section -->
              <v-card class="video-upload-card mb-6 elevation-3">
                <v-card-title class="video-upload-header">
                  <v-icon size="24" color="#d32f2f">mdi-video</v-icon>
                  <span class="section-title">Video Submission</span>
                </v-card-title>

                <v-card-text class="pa-6">
                  <!-- Existing Video Display -->
                  <div
                    v-if="row.AwardVideoPath != null"
                    class="current-video-section mb-6"
                  >
                    <div class="video-header-label">
                      <v-icon size="20" color="#4caf50">mdi-video-check</v-icon>
                      <span class="label-text">Current Video</span>
                    </div>

                    <div class="video-player-wrapper">
                      <video
                        :src="row.AwardVideoPath"
                        controls
                        controlsList="nodownload"
                        class="professional-video-player"
                      ></video>
                      <div class="video-overlay-badge">
                        <v-chip color="#4caf50" text-color="white" small>
                          <v-icon left size="14">mdi-check-circle</v-icon>
                          Submitted
                        </v-chip>
                      </div>
                    </div>
                  </div>

                  <v-alert type="warning" class="video-info-alert mb-4">
                    <v-icon color="#d32f2f" class="mr-2"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <strong>Video Requirements:</strong> MP4, AVI, or MOV
                    format, maximum 25MB
                  </v-alert>

                  <!-- Video Upload Section -->
                  <div class="upload-wrapper">
                    <div class="upload-label">
                      <v-icon size="18" color="#d32f2f" class="mr-2"
                        >mdi-video-plus</v-icon
                      >
                      Upload Video <small>(optional)</small>
                    </div>
                    <v-file-input
                      ref="UploadVideo"
                      v-model="UploadVideo"
                      counter
                      show-size
                      truncate-length="47"
                      :clearable="false"
                      accept="video/*"
                      label="Choose a video file"
                      class="video-input"
                    >
                      <template v-slot:append-outer>
                        <v-icon
                          v-if="UploadVideo && UploadVideo.name"
                          color="#4caf50"
                          @click="resetUploadVideo"
                        >
                          mdi-close-circle
                        </v-icon>
                      </template>
                    </v-file-input>
                  </div>

                  <!-- Video Preview Info -->
                  <div
                    v-if="UploadVideo && UploadVideo.name"
                    class="video-preview-info mt-3"
                  >
                    <v-chip color="#4caf50" text-color="white" small>
                      <v-icon left size="16">mdi-check-circle</v-icon>
                      {{ UploadVideo.name }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>

              <v-row wrap v-if="ProgessStart == 1">
                <v-col align="center" cols="12" md="12">
                  <v-progress-circular
                    :rotate="180"
                    :size="100"
                    :width="15"
                    :value="uploadPercentage"
                    color="#00a4ef"
                  >
                    {{ uploadPercentage }}
                  </v-progress-circular>
                  <h3 class="red--text">
                    Please wait, we are uploading your details. Time may vary
                    based on your internet connection.
                  </h3>
                </v-col>
              </v-row>
              <!-- Professional Submit Section -->
              <div class="submit-section" v-if="row != ''">
                <v-card class="submit-card" elevation="3">
                  <v-card-text class="text-center pa-6">
                    <div class="submit-info mb-4">
                      <h3 class="submit-title">Ready to Save Changes?</h3>
                      <p class="submit-description">
                        You can save your progress or submit your final
                        application.
                      </p>
                    </div>

                    <div class="action-buttons">
                      <v-btn
                        @click.prevent="getTotalNatConLomAwardsDetails(4)"
                        :loading="SaveFlag"
                        :disabled="
                          !valid1 ||
                          !NatconRegistrationFlag ||
                          !ProfileVerifiedFlag ||
                          !AgeVerificationFlag
                        "
                        elevation="3"
                        rounded
                        large
                        color="#4caf50"
                        class="submit-btn white--text mr-4"
                      >
                        <v-icon left>mdi-content-save</v-icon>
                        Save Draft
                      </v-btn>

                      <v-btn
                        :disabled="
                          !valid1 ||
                          !NatconRegistrationFlag ||
                          !ProfileVerifiedFlag ||
                          !AgeVerificationFlag
                        "
                        @click.prevent="getTotalNatConLomAwardsDetails(3)"
                        :loading="SubmitFlag"
                        elevation="3"
                        rounded
                        large
                        color="#1976d2"
                        class="submit-btn white--text"
                      >
                        <v-icon left>mdi-send</v-icon>
                        Final Submit
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Dialogs preserved -->
    <v-dialog v-model="addRecordPrompt" persistent max-width="70%">
      <answer-attachment-edit
        pageTitle="Add Project Details"
        :recordData="selectedRecord"
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt($event)"
        v-if="addRecordPrompt"
      ></answer-attachment-edit>
    </v-dialog>

    <v-dialog v-model="addAttachmentRecordPrompt" persistent max-width="70%">
      <attachment-edit
        pageTitle="Add Additional Attachment"
        :addRecordPrompt="addAttachmentRecordPrompt"
        @hideAddRecordPrompt="hideAddAttachmentRecordPrompt($event)"
        v-if="addAttachmentRecordPrompt"
      ></attachment-edit>
    </v-dialog>
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

import AnswerAttachmentEdit from "@/view/pages/erp/jci-award/natcon/common/AnswerAttachmentEdit.vue";
import MemberDetails from "@/view/pages/erp/jci-award/natcon/common/MemberDetails.vue";
import AttachmentEdit from "@/view/pages/erp/jci-award/natcon/common/AttachmentEdit.vue";
import { VueEditor } from "vue2-editor"; // Import Vue-Quill-Editor

export default {
  mixins: [common],
  components: {
    AnswerAttachmentEdit,
    MemberDetails,
    AttachmentEdit,
    VueEditor,
  },
  data() {
    return {
      ProgessStart: 0,
      uploadPercentage: 0,
      OverlayLoadingFlag: false,

      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SaveFlag: false,
      SubmitFlag: false,
      CardLoadingFlag: false,
      SearchFlag: false,
      ResultFlag: false,
      editorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            ["clean"],
          ],
        },
        placeholder: "Please provide your detailed answer here...",
      },
      UploadFlag: false,
      addButtonFlag: true,

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      Member: {},

      Status: "",

      NatconIndividualAwardStartDate: "",
      NatconIndividualAwardEndDate: "",
      TotalNatconIndividualAward: 0,
      TotalApplied: 0,
      TotalPartiallySaved: 0,

      StartDateFlag: false,
      EndDateFlag: false,

      UploadVideo: [],
      UploadVideoRules: [
        (value) =>
          !value ||
          value.size < 25000000 ||
          "Upload Video size should be less than 25 MB!",
      ],

      rows: {},
      ProfileVerifiedFlag: false,
      NatconRegistrationFlag: false,
      AgeVerificationFlag: false,
      AgeVerificationMsg: "",
      AwardTypeId: "",
      AwardId: "",
      LomId: "",

      row: {
        AnswerAttachmentOfficers: [],
        AwardAnswersArray: [],
      },
      // CriteriaAnswers: [],
      Project: [],
      AllImages: [],
      AllProject: [],
      AllProjectMax: 10,
      AllProjectCount: 0,
      addAttachmentRecordPrompt: false,

      selectedRecord: "",
      Id: "",
      showTextBox: false,

      addRecordPrompt: false,

      ImageUploadFlag: false,

      AnswerRules: [(v) => !!v || "Answer is required"],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        this.PageTitle = tr.PageTitle + " - " + zone_name;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    row: function () {
      console.log("watch row called");
      this.getMemberIdOptions();
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
      this.MemberId = this.row.MemberId;
    },
    MemberId: function () {
      console.log("MemberId watch called");
      this.Member = {};
      this.getSelectedMemberDetails();
      this.getAwardTypeDetials();
    },
  },
  mounted() {},
  methods: {
    // HTML Editor related methods
    getCharacterCount(html) {
      if (!html) return 0;
      // Remove HTML tags and entities to count only visible text
      const text = html.replace(
        /<[^>]*>|&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;/g,
        ""
      );
      return text.length;
    },

    onTextChange(event, item) {
      // Get the Quill editor instance from the event
      const editor = event.editor;
      const maxLength = item.QuestionsCharsCount;

      // Calculate the current text length without HTML tags
      const currentLength = this.getCharacterCount(item.AnswerText);

      // If the length exceeds the limit, prevent further input
      if (currentLength > maxLength) {
        // Get the current selection
        const range = editor.getSelection();

        // If there is no selection, we need to restore the previous text
        if (range && range.length === 0) {
          // Store current cursor position
          const cursorPosition = range.index;

          // Use DOM manipulation to truncate the HTML content
          const editorRoot = editor.root;
          const editorContent = editorRoot.innerHTML;

          // Create a temporary div to manipulate the HTML
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = editorContent;

          // Function to recursively process text nodes
          const processNode = (node, currentCount) => {
            if (currentCount >= maxLength) {
              // Remove node completely if we're already at the limit
              if (node.parentNode) {
                node.parentNode.removeChild(node);
              }
              return currentCount;
            }

            if (node.nodeType === Node.TEXT_NODE) {
              const nodeLength = node.textContent.length;
              if (currentCount + nodeLength > maxLength) {
                // Truncate this text node
                const remainingChars = maxLength - currentCount;
                node.textContent = node.textContent.substring(
                  0,
                  remainingChars
                );
                return maxLength;
              } else {
                return currentCount + nodeLength;
              }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              // Skip certain elements that don't contribute to visible text
              if (node.tagName === "SCRIPT" || node.tagName === "STYLE") {
                return currentCount;
              }

              // Process child nodes
              let count = currentCount;
              const childNodes = Array.from(node.childNodes);
              for (const childNode of childNodes) {
                count = processNode(childNode, count);
                if (count >= maxLength) break;
              }
              return count;
            }

            return currentCount;
          };

          // Process the content
          processNode(tempDiv, 0);

          // Update the editor content
          editor.setContents(editor.clipboard.convert(tempDiv.innerHTML));

          // Restore cursor position, but don't go beyond the new content
          const newLength = editor.getText().length;
          const newPosition = Math.min(cursorPosition, newLength - 1);
          editor.setSelection(newPosition > 0 ? newPosition : 0);
        }
      }

      // Update validation rules
      if (currentLength >= maxLength) {
        if (!this.AnswerRules.includes(this.validateMaxLength)) {
          this.AnswerRules.push(this.validateMaxLength);
        }
      } else {
        const index = this.AnswerRules.indexOf(this.validateMaxLength);
        if (index !== -1) {
          this.AnswerRules.splice(index, 1);
        }
      }
    },

    validateMaxLength(v) {
      // This is a custom validation rule for the rich text editor
      // It will be used by Vuetify's validation system
      const item = this.row.AwardAnswersArray.find(
        (item) => item.AnswerText === v
      );
      if (item && this.getCharacterCount(v) > item.QuestionsCharsCount) {
        return "Character limit exceeded";
      }
      return true;
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "national_individual_award",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      var id = this.$route.query.id;
      console.log({ id });
      this.AwardId = id;

      this.getMemberIdOptions();
      this.getTableRecords();
      this.getAwardTypeDetials();
    },
    resetUploadVideo() {
      console.log("resetUploadVideo called.");
      this.UploadVideo = "";
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 7,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getSelectedMemberDetails() {
      console.log("getSelectedMemberDetails called");
      this.Member = {};
      this.ProfileVerifiedFlag = false;
      this.NatconRegistrationFlag = false;
      this.AgeVerificationFlag = false;
      this.AgeVerificationMsg = "";
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.Member = member;

        this.ProfileVerifiedFlag = member.ProfileStatus === 1 ? true : false;
        // Check if profile is updated/verified
        if (member.ProfileStatus === 0) {
          Swal.fire({
            icon: "error",
            title: "Profile Not Verified",
            html: `<div style="text-align: left;">
          <p><strong>Member Profile Verification Required</strong></p>
          <p>The selected member's profile is not yet verified.</p>
          <p style="margin-bottom: 0; color: #d32f2f;">
            <i class="mdi mdi-alert-circle" style="font-size:20px; vertical-align:middle;"></i>
            Please ensure the member completes their profile verification before applying for this award.
          </p>
        </div>`,
            confirmButtonColor: "#d32f2f",
            confirmButtonText: "OK",
          });
        }
      }
    },
    getAwardTypeDetials() {
      console.log("getAwardTypeDetials called");

      var validate1 = true;
      console.log({ validate1 });

      if (validate1) {
        this.CardLoadingFlag = true;
        this.NatconRegistrationFlag = false;
        this.AgeVerificationFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/show";

        var upload = {
          UserInterface: 1,
          AwardType: this.AwardTypeId,
          AwardGroup: 1,
          Member: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;
        this.NatconRegistrationCount = "";
        this.NatconRegistrationFlag = false;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.CardLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              console.log("records = " + JSON.stringify(records));
              thisIns.AwardTypeTitleTxt = records.AwardTypeTitleTxt;
              thisIns.AwardCategoryId = records.AwardCategoryId;
              thisIns.NatconRegistrationFlag = records.NatconRegistrationFlag;
              thisIns.NatconRegistrationCount = records.NatconRegistrationCount;
              thisIns.AgeVerificationFlag = records.AgeVerificationFlag;
              thisIns.AgeVerificationMsg = records.AgeVerificationMsg;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.CardLoadingFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    resetForm() {
      console.log("resetForm called");
      var rows = this.CriteriaAnswers;

      rows.map((row, index) => {
        row.AnswerText = "";
        row.AllProject = {};
      });

      this.getTableRecords();
      this.getAwardTypeDetials();
    },
    addNewRow(tr) {
      console.log("addNewRow called");
      console.log({ tr });
      this.selectedRecord = tr;
      this.addRecordPrompt = true;
    },
    deleteRow(id, index) {
      console.log("deleteRow called");
      console.log({ id });
      console.log({ index });
      if (index > -1) {
        var row = this.row.AwardAnswersArray;

        row.forEach((data, k) => {
          console.log({ k });
          if (id == k) {
            data.EventDetails.splice(index, 1);
          }
        });

        console.log("row = ", this.row);
      }
    },
    hideAddRecordPrompt(tr) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log({ tr });

      if (tr.EventId != "") {
        // this.Id = tr.Index;
        console.log("tr.index = ", tr.Index);

        var row = this.row.AwardAnswersArray;

        row.forEach((data, index) => {
          console.log("SNo = ", data.SNo);

          if (tr.Index == data.SNo) {
            console.log("Limit not Crossed");

            var n1 = data.QuestionsAttachmentMax;
            var n2 = data.EventDetails.length;
            console.log({ n1 }, { n2 });

            if (n1 > n2) {
              console.log("Limit not Crossed");

              data.EventDetails.push({
                EventId: tr.EventId,
                EventName: tr.EventName,
                EventDate: tr.EventDate,
                EventImagesArray: tr.EventPhoto,
                AnswerEventImages: tr.EventImages,
                AnswerInvitationImages: tr.InvitationImages,
                AnswerJciEventDescription: tr.EventDescription,
              });
            } else {
              console.log("Maximum Limit Crossed");
              var Message = "Attachment Maximum Count reached its limit.";
              this.sweetAlert("error", Message, false);
            }
          }
        });

        console.log("row = ", this.row);
      }
    },
    deleteRow1(id) {
      console.log("deleteRow1 called");
      console.log({ id });

      if (
        this.row &&
        this.row.AnswerAttachmentOfficers &&
        this.row.AnswerAttachmentOfficers.length > id
      ) {
        this.row.AnswerAttachmentOfficers.splice(id, 1);
        this.calculateAllProjectCount();
      }
    },
    calculateAllProjectCount() {
      console.log("calculateAllProjectCount called");
      const answerAttachmentCount =
        this.row && this.row.AnswerAttachmentOfficers
          ? this.row.AnswerAttachmentOfficers.length
          : 0;
      const allProjectCount = this.AllProject ? this.AllProject.length : 0;
      this.AllProjectCount = answerAttachmentCount + allProjectCount;
      console.log("AllProjectCount =", this.AllProjectCount);
    },
    addAttachmentNewRow() {
      console.log("addAttachmentNewRow called");
      this.addAttachmentRecordPrompt = true;
    },
    deleteAttachmentRow(id) {
      console.log("deleteAttachmentRow called");
      console.log({ id });

      this.AllProject.splice(id, 1);
      this.AllImages.splice(id, 1);
    },
    hideAddAttachmentRecordPrompt(tr) {
      console.log("hideAddAttachmentRecordPrompt called");
      this.addAttachmentRecordPrompt = false;
      console.log({ tr });

      if (tr.EventName != "") {
        var count = this.AllProject.length;
        var id = count == 0 ? 0 : count + 1;

        this.AllProject.push({
          AnswerEventId: "",
          AnswerEventName: tr.EventName,
          AnswerEventDate: tr.EventDate,
          AnswerEventDescription: tr.EventDescription,
          AnswerEventImageName: tr.EventImageName,
          AnswerEventImageUrl: tr.EventImageUrl,
          AnswerEventImage: tr.EventImage,
          AnswerInvitationImages: tr.InvitationImages,
          AnswerJciEventDescription: tr.EventDescription,
          EventPhoto: tr.WebsiteImages,
          EventImages: tr.EventImages,
          InvitationImages: tr.InvitationImages,
        });

        this.AllImages.push({
          AnswerEventId: "",
          AnswerEventName: tr.EventName,
          UploadedImage: tr.EventImage.UploadedImage,
        });
      }
      console.log("AllProject = " + JSON.stringify(this.AllProject));
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardId = this.AwardId;
      console.log({ AwardId });
      this.AwardTypeId = "";
      if (AwardId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/show";
        var upload = {
          UserInterface: 1,
          Award: AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.RecordFlag = flag;
            thisIns.NatconRegistrationFlag = records.NatconRegistrationFlag;
            thisIns.AgeVerificationFlag = records.AgeVerificationFlag;
            thisIns.AgeVerificationMsg = records.AgeVerificationMsg;
            thisIns.AwardTypeId = records.AwardTypeId;
            thisIns.LomId = records.LomId;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.row = records;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award details not found.";
        console.log("error=" + message);
      }
    },
    getTotalNatConLomAwardsDetails(status) {
      console.log("getTotalNatConLomAwardsDetails called");

      var validate1 = true;
      console.log({ validate1 });

      console.log({ status });
      this.Status = status;

      if (validate1) {
        this.CardLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/total-awards";

        var AwardCategory = 5;
        var AwardGroup = 1;

        if (this.RoleId == 2) {
          // For Admin
          var upload = {
            UserInterface: 1,
            AwardCategory: AwardCategory,
            AwardGroup: AwardGroup,
            Lom: this.LomCode,
          };
        } else {
          // For Others
          var upload = {
            UserInterface: 1,
            AwardCategory: AwardCategory,
            AwardGroup: AwardGroup,
          };
        }

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.CardLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              console.log("records = " + JSON.stringify(records));
              thisIns.rows = records;
              thisIns.NatconIndividualAwardStartDate = records.StartDateTxt;
              thisIns.NatconIndividualAwardEndDate = records.EndDateTxt;
              thisIns.TotalNatconIndividualAward = records.TotalAward;
              thisIns.TotalApplied = records.TotalApplied;
              thisIns.TotalPartiallySaved = records.TotalPartiallySaved;
              thisIns.StartDateFlag = records.StartDateFlag;
              thisIns.EndDateFlag = records.EndDateFlag;

              console.log(
                "StartDateFlag=" +
                  records.StartDateFlag +
                  ", EndDateFlag=" +
                  records.EndDateFlag
              );

              if (thisIns.StartDateFlag && thisIns.EndDateFlag) {
                thisIns.confirmAlert(status);
              } else {
                thisIns.deadlineAlert();
              }
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.CardLoadingFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    deadlineAlert() {
      console.log("deadlineAlert called");
      var htmlTxt = "";
      htmlTxt +=
        "<h3> Natcon Lom Awards Bidding ended at <b> " +
        this.NatconIndividualAwardEndDate +
        " </b> </h3>";
      // htmlTxt += "<br/> Start <b> " + this.NatconIndividualAwardEndDate + " </b>";

      Swal.fire({
        title: "Sorry !",
        text: "",
        icon: "warning",
        html: htmlTxt,
      });
    },
    confirmAlert(status) {
      console.log("confirmAlert called");

      var validate1 = this.$refs.form1.validate();
      var member_id = false;
      var photo_flag = false;
      member_id =
        this.MemberId == null || this.MemberId == "" ? "" : this.MemberId;
      photo_flag = this.Member.photo_flag ? true : false;

      var DocumentFlag = true;
      console.log({ DocumentFlag });

      console.log({ status }, { validate1 }, { member_id }, { photo_flag });
      if (validate1 && member_id != "" && photo_flag && DocumentFlag) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm(status);
          } else {
            this.sweetAlert("error", "You cancelled the process", false);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "kindly answer all the questions.";
        }
        if (member_id == "") {
          message = "Kindly select Member";
        }
        if (!photo_flag) {
          message = "Member Profile not Updated.";
        }
        if (!DocumentFlag) {
          message = "Age document not Updated.";
        }

        Swal.fire({
          // title: "Are you sure?",
          icon: "error",
          html: message,
        });
        // this.sweetAlert("error", message, false);
      }
    },
    submitForm(status) {
      console.log("submitForm is called");
      this.ProgessStart = 1;
      this.OverlayLoadingFlag = true;
      if (status == 4) {
        this.SaveFlag = true;
      } else {
        this.SubmitFlag = true;
      }

      console.log({ status });
      var count = this.AllImages.length;

      var video = this.UploadVideo != {} ? this.UploadVideo : {};
      console.log({ video });

      this.AllImages.forEach((row, index) => {
        console.log({ index });
        row.AnswerEventId = index;
        console.log("AllImages=" + JSON.stringify(this.AllImages));
      });

      this.AllProject.forEach((item, index) => {
        console.log({ index });
        item.AnswerEventId = index;
        console.log("AllProject=" + JSON.stringify(this.AllProject));
      });

      var inputData = {
        ActiveStatus: status,
        Member: this.MemberId,
        AwardGroup: 1,
        AwardCategory: 5,
        Award: this.AwardId,
        CriteriaAnswers: this.row,
        AnswerAttachmentOfficers: this.row.AnswerAttachmentOfficers,
        AllProject: this.AllProject,
        AllImagesCount: count,
      };
      console.log("inputData=" + JSON.stringify(inputData));

      let upload = new FormData();
      upload.append("UserInterface", 1);
      upload.append("InputData", JSON.stringify(inputData));
      upload.append("UploadVideo", video);

      this.AllImages.forEach((row, index) => {
        var id = index + 1;
        console.log({ id });
        var UploadedImage = row["UploadedImage"];
        var EventId = row["AnswerEventId"];
        console.log({ UploadedImage }, { EventId });

        upload.append("AllImages" + index, UploadedImage, EventId);
      });

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/award/national-award-update";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          // "Content-Type": "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgessStart = 0;
          thisIns.OverlayLoadingFlag = false;

          if (status == 4) {
            thisIns.SaveFlag = false;
          } else {
            thisIns.SubmitFlag = false;
          }

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);

            thisIns.$router.push("/national/individual-award/list");
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.ProgessStart = 0;
          thisIns.OverlayLoadingFlag = false;
          if (status == 4) {
            thisIns.SaveFlag = false;
          } else {
            thisIns.SubmitFlag = false;
          }
        });
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#award-edit {
  background-color: #f5f7fa;
  min-height: 100vh;
  font-family: "Roboto", Arial, sans-serif;

  .natcon-alert-card {
    border-left: 4px solid #ff0505;
    background: linear-gradient(
      90deg,
      rgba(25, 118, 210, 0.03),
      rgba(255, 255, 255, 0.01)
    );
    border-radius: 8px;
    transition: box-shadow 0.18s ease, transform 0.18s ease;
  }

  .natcon-alert-card:hover {
    box-shadow: 0 6px 18px rgba(25, 118, 210, 0.08);
    transform: translateY(-2px);
  }

  .natcon-alert-title {
    font-weight: 700;
    font-size: 1.05rem;
    color: #ff0505;
  }

  .natcon-alert-msg {
    color: #ff0505;
    margin-top: 6px;
    font-size: 0.95rem;
    line-height: 1.35;
  }

  /* success card for NatCon registration */
  .natcon-success-card {
    border-left: 4px solid #2e7d32;
    background: linear-gradient(
      90deg,
      rgba(46, 125, 50, 0.04),
      rgba(255, 255, 255, 0.01)
    );
    border-radius: 8px;
    transition: box-shadow 0.18s ease, transform 0.18s ease;
  }

  .natcon-success-card:hover {
    box-shadow: 0 6px 18px rgba(46, 125, 50, 0.08);
    transform: translateY(-2px);
  }

  .professional-overlay {
    .loading-container {
      text-align: center;
      color: white;

      .loading-text {
        font-size: 1.05rem;
        margin: 0;
        font-weight: 500;
      }
    }
  }

  .main-form-container {
    border-radius: 12px !important;
    overflow: hidden;
    background: white;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.08) !important;
  }

  .professional-form-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 1px solid #e6eef9;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
    }

    .form-main-title {
      font-size: 1.6rem;
      font-weight: 700;
      color: #263238;
      margin: 0;
    }

    .award-badge {
      margin-top: 0.5rem;
    }

    .action-buttons {
      display: flex;
      gap: 0.5rem;
    }
  }

  .description-section {
    .description-wrapper {
      display: flex;
      align-items: center;
      background: rgba(25, 118, 210, 0.04);
      padding: 0.9rem;
      border-radius: 8px;
      border-left: 4px solid #1976d2;

      .form-description {
        margin: 0;
        color: #455a64;
      }
    }
  }

  .form-main-content {
    padding: 1.5rem 2rem;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  }

  .award-details-card,
  .member-selection-card,
  .criteria-card,
  .submit-card {
    border-radius: 12px !important;
    border: 1px solid #e9f2ff;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.04);
  }

  .award-details-header,
  .member-selection-header,
  .criteria-header {
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
    border-bottom: 1px solid #e6eef9;
    padding: 1rem 1.5rem;

    .section-title {
      font-size: 1.2rem;
      font-weight: 600;
      color: #263238;
    }
  }

  .detail-item {
    margin-bottom: 0.5rem;

    .detail-label {
      font-size: 0.9rem;
      color: #1976d2;
      margin-bottom: 6px;
      font-weight: 600;
    }

    .detail-value {
      background: #fbfdff;
      padding: 10px;
      border-radius: 8px;
      color: #263238;
      font-weight: 500;
    }
  }

  .member-selection-card .member-selection-item,
  .member-selection-card .member-dropdown-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .member-avatar {
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #eef3fb;
  }

  .html-editor-wrapper {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
  }

  .professional-editor .ql-container {
    min-height: 140px;
  }

  .character-counter {
    padding: 6px 10px;
    font-size: 0.85rem;
    color: #607d8b;
    text-align: right;
    background: #fafafa;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .character-counter.error--text {
    color: #d32f2f;
    background: rgba(244, 67, 54, 0.06);
    font-weight: 600;
  }

  .criteria-detail-card {
    background: #fff8e1;
    border: 1px solid #ffecb3;
    padding: 12px;
    border-radius: 8px;
  }

  .criteria-title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #bf360c;
    margin: 0;
  }

  .attachments-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .attachments-grid .attachment-card {
    border-radius: 8px !important;
    transition: transform 0.18s, box-shadow 0.18s;
  }

  .attachment-actions {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
  }

  .event-image {
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    object-fit: cover;
    transition: transform 0.2s;
  }

  .event-image:hover {
    transform: scale(1.04);
  }

  .no-attachments-state {
    text-align: center;
    padding: 1rem;
    color: #9e9e9e;
  }

  /* Additional Attachments Section */
  .attachments-additional-card {
    border-radius: 12px !important;
    border: 1px solid #e0e0e0;
    background: white;
    margin-top: 1.5rem;
  }

  .attachments-additional-header {
    background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
    border-bottom: 1px solid #ce93d8;
    padding: 1.5rem;

    .section-title {
      font-size: 1.3rem;
      font-weight: 600;
      color: #6a1b9a;
    }
  }

  .add-attachment-action-btn {
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.15);
      background-color: rgba(123, 31, 162, 0.1) !important;
    }
  }

  .info-alert {
    background-color: rgba(74, 20, 140, 0.04);
    border: 1px solid rgba(74, 20, 140, 0.2);
    border-radius: 8px;
    padding: 1rem;

    .text-sm {
      font-size: 0.9rem;
      line-height: 1.4;
      color: #424242;
    }

    .requirements-title {
      display: flex;
      align-items: center;
      margin-bottom: 0.75rem;
      font-size: 0.95rem;
    }

    .requirements-list {
      margin: 0;
      padding-left: 1.5rem;
      line-height: 1.8;

      li {
        color: #424242;
        font-size: 0.9rem;
        margin-bottom: 0.4rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .empty-state-container {
    text-align: center;
    padding: 2rem;
    border: 2px dashed #ce93d8;
    border-radius: 8px;
    background-color: #fafafa;
    color: #999;

    p {
      margin: 0;
      color: #666;
      font-weight: 500;
    }
  }

  .image-gallery {
    .image-card {
      border-radius: 8px;
      position: relative;
      overflow: hidden;
      transition: all 0.3s ease;
      border: 1px solid #e0e0e0;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      }

      .image-delete-action {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        background-color: rgba(211, 47, 47, 0.9);
        border-radius: 0 0 0 8px;
        padding: 2px;

        .delete-btn {
          transition: all 0.2s ease;

          &:hover {
            background-color: rgba(211, 47, 47, 1) !important;
          }
        }
      }

      .image-preview {
        border-bottom: 1px solid #e0e0e0;
      }

      .image-details {
        background-color: #fafafa;

        .detail-item {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 0.85rem;

          .detail-label {
            font-weight: 600;
            color: #424242;
            min-width: 40px;
          }

          .detail-value {
            color: #666;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  /* Video Upload Section */
  .video-upload-card {
    border-radius: 12px !important;
    border: 1px solid #e0e0e0;
    background: white;
  }

  .video-upload-header {
    background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
    border-bottom: 1px solid #ef5350;
    padding: 1.5rem;

    .section-title {
      font-size: 1.3rem;
      font-weight: 600;
      color: #c62828;
    }
  }

  .video-info-alert {
    background-color: rgba(211, 47, 47, 0.04);
    border: 1px solid rgba(211, 47, 47, 0.2);
    border-radius: 8px;
    padding: 1rem;
  }

  /* Current Video Section */
  .current-video-section {
    .video-header-label {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 2px solid #e8f5e9;

      .label-text {
        font-size: 1.1rem;
        font-weight: 600;
        color: #2e7d32;
      }
    }

    .video-player-wrapper {
      position: relative;
      max-width: 800px;
      margin: 0 auto;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      background: #000;

      .professional-video-player {
        width: 100%;
        max-height: 450px;
        display: block;
        background: #000;
        outline: none;

        &::-webkit-media-controls-panel {
          background-color: rgba(0, 0, 0, 0.8);
        }
      }

      .video-overlay-badge {
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 10;
        animation: fadeInDown 0.5s ease;

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 80px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent);
        pointer-events: none;
      }
    }
  }

  .upload-wrapper {
    margin-top: 1rem;

    .upload-label {
      display: flex;
      align-items: center;
      font-weight: 600;
      color: #424242;
      margin-bottom: 12px;
    }

    .video-input {
      &:deep(.v-input__slot) {
        min-height: 56px;
        background-color: #f5f5f5;
        border-radius: 8px;
        transition: all 0.2s ease;
      }

      &:deep(input) {
        color: #424242;
        font-size: 0.95rem;
      }

      &:hover:deep(.v-input__slot) {
        background-color: #eeeeee;
      }
    }
  }

  .video-preview-info {
    .video-chip {
      display: flex;
      gap: 6px;
      font-weight: 500;
    }
  }

  /* Responsive Design */
  @media (max-width: 960px) {
    .attachments-additional-header,
    .video-upload-header {
      padding: 1.2rem;

      .section-title {
        font-size: 1.1rem;
      }
    }

    .current-video-section {
      .video-player-wrapper {
        .professional-video-player {
          max-height: 350px;
        }
      }
    }

    .image-gallery {
      .image-card {
        .image-details {
          .detail-item {
            font-size: 0.8rem;
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .attachments-additional-header,
    .video-upload-header {
      padding: 1rem;

      .section-title {
        font-size: 1rem;
      }
    }

    .current-video-section {
      .video-header-label {
        .label-text {
          font-size: 1rem;
        }
      }

      .video-player-wrapper {
        border-radius: 8px;

        .professional-video-player {
          max-height: 250px;
        }

        .video-overlay-badge {
          top: 8px;
          right: 8px;
        }
      }
    }

    .empty-state-container {
      padding: 1.5rem;

      p {
        font-size: 0.9rem;
      }
    }

    .image-gallery {
      .image-card {
        .image-details {
          .detail-item {
            font-size: 0.75rem;
            flex-direction: column;
            align-items: flex-start;
          }
        }
      }
    }

    .upload-label {
      font-size: 0.95rem;
    }
  }

  .submit-section .submit-card {
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
    border: 1px solid #e6f2ff;
  }

  .submit-btn {
    text-transform: none;
    font-weight: 600;
  }

  @media (max-width: 1024px) {
    .professional-form-header .header-content {
      flex-direction: column;
      gap: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-form-container {
      margin: 0.5rem;
      border-radius: 10px !important;
    }

    .form-main-content {
      padding: 1rem;
    }

    .action-buttons {
      flex-direction: column;
    }
  }
}
</style>